import {ClientEntity} from "@common-core/coat-operational-hierarchy-appsync-model";
import {CreatePlan} from "../view-model";

import {
  toOperationalEntity,
  toOperationalEntityWithTenant
} from "./toOperationalEntity";

/**
 * This function transforms a {@link ClientEntity} into the {@link CreatePlan}
 * view model.
 *
 * Note that this function does not apply business rules during transformation;
 * it is only responsible for transforming the API model to the view model.
 *
 * @param source
 * @param withTenant
 */
export const toCreatePlan = (
  source: ClientEntity,
  withTenant: boolean = false
): CreatePlan => ({
  source,
  newEntity: withTenant
    ? toOperationalEntityWithTenant(source)
    : toOperationalEntity(source)
});
